import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="list"
export default class extends Controller {
  // actionLink/dropdownMenu/arrow/count are used by shared/admin/_batch_actions.
  // deleteLink/batchLink are used by admin/privileges/index.
  static targets = ["batchActions", "mainCheckbox", "rowCheckbox", "actionLink", "count", "dropdownMenu", "arrow", "deleteLink", "batchLink"]

  connect() {
    this.updateBatchActions()
  }

  disconnect() {
    if (this.dropdownTimeout) {
      clearTimeout(this.dropdownTimeout)
    }
  }

  toggleDropdown(event) {
    event.stopPropagation()
    if (this.hasDropdownMenuTarget) {
      this.dropdownMenuTarget.classList.toggle('hidden')

      if (this.dropdownTimeout) {
        clearTimeout(this.dropdownTimeout)
      }
      this.dropdownTimeout = setTimeout(() => {
        this.dropdownMenuTarget.classList.toggle('opacity-0') // we will toggle opacity after a short delay to allow the aniamtion transition to work
      }, 10)
    }

    if (this.hasArrowTarget) {
      this.arrowTarget.classList.toggle('rotate-180')
    }
  }

  closeDropdown(event) {
    if (this.hasDropdownMenuTarget && this.hasBatchActionsTarget) {
      if (!this.batchActionsTarget.contains(event.target)) {
        this.dropdownMenuTarget.classList.add('hidden')
        this.dropdownMenuTarget.classList.add('opacity-0')

        if (this.hasArrowTarget) {
          this.arrowTarget.classList.remove('rotate-180')
        }
      }
    }
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.rowCheckboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateBatchActions()
  }

  toggleRow() {
    const allChecked = this.rowCheckboxTargets.every(cb => cb.checked)
    const someChecked = this.rowCheckboxTargets.some(cb => cb.checked)

    if (this.hasMainCheckboxTarget) {
      this.mainCheckboxTarget.checked = allChecked
      this.mainCheckboxTarget.indeterminate = someChecked && !allChecked
    }

    this.updateBatchActions()
  }

  #appendIds(baseUrl, ids) {
    const separator = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${separator}ids=${ids.join(',')}`
  }

  updateBatchActions() {
    const selectedCheckboxes = this.rowCheckboxTargets.filter(cb => cb.checked)
    const selectedIds = selectedCheckboxes.map(cb => cb.dataset.id)

    if (this.hasBatchActionsTarget) {
      if (selectedIds.length > 0) {
        this.batchActionsTarget.classList.remove('hidden')
      } else {
        this.batchActionsTarget.classList.add('hidden')

        // Force close menu and reset arrow if all boxes are unchecked
        if (this.hasDropdownMenuTarget) {
           this.dropdownMenuTarget.classList.add('hidden')
           this.dropdownMenuTarget.classList.add('opacity-0')
        }
        if (this.hasArrowTarget) {
           this.arrowTarget.classList.remove('rotate-180')
        }
      }
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selectedIds.length
    }

    //  Formatting IDs for Rails Array
    if (this.hasActionLinkTarget && selectedIds.length > 0) {
      this.actionLinkTargets.forEach(link => {
        const baseUrl = link.dataset.baseUrl
        const url = new URL(baseUrl, window.location.origin)

        url.searchParams.delete('ids[]')
        url.searchParams.delete('ids')

        // ids as an array: ?ids[]=1&ids[]=2&ids[]=3
        selectedIds.forEach(id => {
          url.searchParams.append('ids[]', id)
        })

        link.href = url.pathname + url.search
      })
    }

    // Update delete link with selected IDs (legacy target)
    if (this.hasDeleteLinkTarget) {
      const baseUrl = this.deleteLinkTarget.dataset.baseUrl || '/admin/contacts/batch_delete'
      this.deleteLinkTarget.href = this.#appendIds(baseUrl, selectedIds)
      const countText = this.deleteLinkTarget.querySelector('[data-count]')
      if (countText) countText.textContent = selectedIds.length
    }

    // Update all generic batch links with selected IDs
    this.batchLinkTargets.forEach(link => {
      const baseUrl = link.dataset.baseUrl
      if (baseUrl) {
        link.href = this.#appendIds(baseUrl, selectedIds)
        const countText = link.querySelector('[data-count]')
        if (countText) countText.textContent = selectedIds.length
      }
    })
  }
}
